"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderQueryResult = void 0;
const tslib_1 = require("tslib");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const react_1 = tslib_1.__importDefault(require("react"));
function RenderQueryResult(props) {
    const { result, renderers } = props;
    if (props.log && result.data) {
        console.error(JSON.stringify(result.data, null, 2));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, renderQueryResult(result, renderers)));
}
exports.RenderQueryResult = RenderQueryResult;
function renderQueryResult(result, renderers) {
    if (result.loading) {
        return renderers.renderLoading ? renderers.renderLoading() : null;
    }
    if (result.error) {
        const errorCode = (0, data_catalog_shared_1.getFirstGraphQLErrorCode)(result.error);
        if (result.data) {
            if (renderers.renderDataWithError) {
                return renderers.renderDataWithError(result.data, errorCode);
            }
            else {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    renderers.renderData(result.data),
                    (0, data_catalog_shared_1.reportGraphQLError)(errorCode)));
            }
        }
        else {
            return renderers.renderError ? renderers.renderError(errorCode) : (0, data_catalog_shared_1.reportGraphQLError)(errorCode);
        }
    }
    if (result.data) {
        return renderers.renderData(result.data);
    }
    return renderers.renderNoData ? renderers.renderNoData() : (0, data_catalog_shared_1.reportNoData)();
}
//# sourceMappingURL=renderQueryResult.js.map